// src/components/molecules/SubmissionDetails/CommentInput.js

import React from "react";
import { Box, TextField, IconButton } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const CommentInput = ({ newComment, setNewComment, handleCommentSubmit }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        mb: 2,
        backgroundColor: "white",
        borderRadius: "50px",
      }}
    >
      <TextField
        fullWidth
        variant="outlined"
        placeholder="Add a comment..."
        value={newComment}
        onChange={(e) => setNewComment(e.target.value)}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "25px 25px 25px 25px", // Maintain rounded corners
            "& fieldset": {
              border: "none", // Remove the outline border
            },
            "&:hover fieldset": {
              border: "none", // Remove border on hover
            },
            "&.Mui-focused fieldset": {
              border: "none", // Remove border on focus
            },
          },
        }}
      />

      <IconButton
        color="primary"
        onClick={handleCommentSubmit}
        sx={{
          backgroundColor: "#1E41FF",
          borderRadius: "50%",
          mr: 1,
          ml: 1,
          "&:hover": {
            backgroundColor: "#219A79",
          },
        }}
      >
        <ArrowForwardIcon sx={{ color: "white" }} />
      </IconButton>
    </Box>
  );
};

export default CommentInput;
